module.exports = __webpack_public_path__ + "img/toast-warning.ccc73a19.svg";